import keys from '../../../../config/keys';

export default {
  '38': keys.UP,
  '40': keys.DOWN,
  '37': keys.LEFT,
  '39': keys.RIGHT
};
